import {
    Card,
    Button,
    Loading,
    BaseTable,
    TableHeader,
    TableNumber,
} from "components"
import { useProfileDetail } from "../utils/useProfileDetail"
import moment from "moment"
import { useEffect, useState } from "react"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { FilterTask } from "../types/FilterTask"
import { useTaskList } from "../utils/useTaskList"
import { IoSendSharp } from "react-icons/io5"
import { useNavigate,  useSearchParams } from "react-router-dom"
import { TASK_STATUS } from "../utils/taskStatus"
import { default_pagination_value } from "utils"
import TaskEdit from "./TaskEdit"

interface TabProps{
    action?:string
    project_id?:string
    approval_view?:boolean
    data_profile?:FormStateProjectProfile
}

export function TabTask(props:TabProps): JSX.Element {
    const navigate = useNavigate()
    const [isLoading , setLoading] = useState(true)
    const { data } = useProfileDetail(props.project_id)
    const [dataProfile, setDataProfile] = useState<FormStateProjectProfile | null>(null);
    const [dayBehind,setDayBehind ] = useState(0)
    const [weekBehind,setWeekBehind ] = useState(0)
    const [searchParams] = useSearchParams();
    const taskId = searchParams.get("task_id");
   
    const [pagination, setPagination] = useState<FilterTask>({
        ...default_pagination_value,
        size: 0,
        pages: 1,
        total: 0,
        project_id:Number(props.project_id)
      })
    
      const tasks = useTaskList({
        params: pagination,
        onSuccess: (paging) => {
          setPagination((prev) => ({
            ...prev,
            ...paging
          }))
        }
      })
        
    
    useEffect(() => {
        if (isLoading && ((!data || data.length === 0) || !tasks)) return;

        setDataProfile(data[0])
        const startDate = data[0].start_date;
        const dueDate = data[0].due_date;
        const today = moment().toDate()
        // Hitung durasi (hari)
        const dayBehind = startDate ? moment(dueDate).diff(moment(today), "days") : 0;
        let weekBehind =  startDate ? moment(today).diff(moment(startDate), "days") : 0;
        weekBehind = Math.ceil(weekBehind / 7 );
        
        setDayBehind(dayBehind)
        setWeekBehind(weekBehind)
        setLoading(false)
        // eslint-disable-next-line
    },[data, tasks])
    

    if(isLoading) return (
        <Loading
        loading={isLoading}
        errorText="No data available"
      />
    )

    return (
        <section className="">
            <section>
                <Card>
                    <Card.Body>
                      
                        <div className="flex flex-row w-full"> 
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {dataProfile?.project_name}
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>START DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.start_date) ? moment(dataProfile.start_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>DUE DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.due_date) ? moment(dataProfile.due_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                 
                    </Card.Body>
                </Card>
            </section>
            
            {(taskId) ? (
                 <TaskEdit />
            ):(
                <section className="p-3">
                    <BaseTable>
                        <TableHeader sticky={true} className="uppercase z-1">
                            <tr>
                                <th>NO</th>
                                <th>Task Id</th>
                                <th>Date</th>
                                <th>Subject</th>
                                <th>Status</th>
                                <th>Progress</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Asign To</th>
                                <th rowSpan={2}>Action</th>
                            </tr>
                        </TableHeader>

                        <tbody>
                            {tasks.data?.length && !tasks.isLoading ? (
                                tasks.data.map((item, key) => {
                                    return (
                                <tr key={key}>
                                <td>
                                    {TableNumber({
                                    index: key,
                                    dataLength: tasks.paging?.limit ?? 5,
                                    pageCurrent: tasks.paging?.page ?? 1,
                                    limit: tasks.paging?.size ?? 1,
                                    totalData: tasks.paging?.total ?? 0
                                    })}
                                </td>
                                <td> {item.trx_code} </td>
                                <td>{moment(item.date_end).format("DD/MM/YYYY")}</td>
                                <td>{item.subject}</td>
                                <td className="text-center">
                                    {TASK_STATUS[item.task_status]}{" "}
                                </td>
                                <td className="text-right">
                                    {parseFloat(item.progress?.toString() ?? "0").toFixed(2)}%
                                </td>
                                <td>{item.date_start ? moment(item.date_start).format("DD/MM/YYYY") : ''}</td>
                                <td>{item.date_end ? moment(item.date_end).format("DD/MM/YYYY") : ''}</td>
                                <td>{item.owner_name}</td>
                                <td>
                                    <div className="flex justify-center items-center">
                                    <Button
                                        size="xs"
                                        color="ghost"
                                        onClick={() => {
                                            // setSelectedTaskId(item.task_id)
                                            navigate(`/project/edit/${dataProfile?.project_id}?tabs=task&task_id=${item.task_id}`)
                                        }}>
                                        <IoSendSharp className="size-4" />
                                    </Button>

                                    {/* {item.candel === 1 ? (
                                        <ActionButton.Delete
                                        onClick={() => {
                                            // modalDelete.setActive(true)
                                            // setDeleteData(item)
                                        }}
                                        />
                                    ) : null} */}
                                    </div>
                                </td>
                                </tr>
                            )
                            })
                        ) : (
                            <tr>
                            <td colSpan={12} className="text-center">
                                <Loading
                                loading={tasks.isLoading}
                                errorText={tasks.isLoading ? "" : "No data available"}
                                />
                            </td>
                            </tr>
                        )}
                        </tbody>
                    </BaseTable>
                </section>

            )}

            
        </section>
    )
}
